import { render, staticRenderFns } from "./activityproduct.vue?vue&type=template&id=73df5b6e&scoped=true"
import script from "./activityproduct.vue?vue&type=script&lang=js"
export * from "./activityproduct.vue?vue&type=script&lang=js"
import style0 from "./activityproduct.vue?vue&type=style&index=0&id=73df5b6e&lang=less"
import style1 from "./activityproduct.vue?vue&type=style&index=1&id=73df5b6e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df5b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73df5b6e')) {
      api.createRecord('73df5b6e', component.options)
    } else {
      api.reload('73df5b6e', component.options)
    }
    module.hot.accept("./activityproduct.vue?vue&type=template&id=73df5b6e&scoped=true", function () {
      api.rerender('73df5b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/activityproduct.vue"
export default component.exports